import { render, staticRenderFns } from "./ValueScore.vue?vue&type=template&id=77832877&scoped=true&"
import script from "./ValueScore.vue?vue&type=script&lang=ts&"
export * from "./ValueScore.vue?vue&type=script&lang=ts&"
import style0 from "./ValueScore.vue?vue&type=style&index=0&id=77832877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77832877",
  null
  
)

export default component.exports